// React
import React from 'react';

// Vendors
import { Icon } from '@equisoft/design-elements-react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

// Src
import NavMenu from './NavMenu/NavMenu';
import { usePluginsConfig } from '@/pluginsConfig';

// Styles
import classes from './TheSideBar.module.scss';

const NavLinkStyled = (props: NavLinkProps) => (
    <NavLink
        className={({ isActive }) =>
            classNames(classes.NavLink, {
                [classes.NavLinkActive]: isActive,
            })
        }
        {...props}
    />
);

const TheSideBar = () => {
    // Hooks
    const { t } = useTranslation();
    const pluginsConfig = usePluginsConfig();

    return (
        <aside className={classes.Root}>
            <nav>
                <NavLinkStyled to="/">
                    <Icon name="home" />
                    {t('app.core.default_layout.home')}
                </NavLinkStyled>
            </nav>

            {pluginsConfig.map((plugin, pluginIndex) => (
                <NavMenu
                    title={plugin.anchorConfig.navTitle}
                    defaultOpen
                    key={pluginIndex}
                >
                    {plugin.anchorConfig.navLinks.map((i, index) => (
                        <NavLinkStyled
                            to={i.to}
                            key={index}
                        >
                            {i.icon}
                            {i.title}
                        </NavLinkStyled>
                    ))}
                </NavMenu>
            ))}
        </aside>
    );
};

export default TheSideBar;
